module.exports = __webpack_public_path__ + "static/media/design post final.e9cd61f6.jpg";